import { jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useDebounce } from "../../hooks/index.js";
import { Box } from "../../Box/index.js";
import { Button } from "../../Button/index.js";
import { Icon } from "../../Icon/index.js";
import { useStyles } from "./GlobalSearchInput.styles.js";
import { GlobalSearchInputSize } from "./GlobalSearchInput.types.js";
const DEBOUNCE_TIMEOUT = 200;
const MAX_LENGTH = 255;
const GlobalSearchInput = ({ value, onChange, placeholder, size = 'medium', inputRef, testId = 'global-search-input-form-test-id' })=>{
    const [currentValue, setCurrentValue] = useState(value);
    const { classes } = useStyles({
        size: GlobalSearchInputSize[size]
    });
    const debouncedInputValue = useDebounce(currentValue, DEBOUNCE_TIMEOUT);
    const isMaxLengthReached = currentValue.length >= MAX_LENGTH;
    const getHelperText = ()=>{
        if (isMaxLengthReached) return 'Введено максимальное количество символов для поискового запроса: 255';
        return '';
    };
    useEffect(()=>{
        setCurrentValue(value);
    }, [
        value
    ]);
    useEffect(()=>{
        onChange(debouncedInputValue);
    }, [
        debouncedInputValue
    ]);
    return /*#__PURE__*/ jsx(TextField, {
        inputRef: inputRef,
        "data-testid": testId,
        value: currentValue,
        onChange: (event)=>{
            const newValue = event.target.value;
            if (newValue.length <= MAX_LENGTH) setCurrentValue(newValue);
        },
        helperText: getHelperText(),
        variant: "outlined",
        fullWidth: true,
        slotProps: {
            input: {
                classes: {
                    root: classes.globalSearchInputRoot,
                    input: classes.globalSearchInput,
                    notchedOutline: classes.notchedOutline
                },
                startAdornment: /*#__PURE__*/ jsx(Box, {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    px: "8",
                    position: "absolute",
                    left: 0,
                    width: "56px",
                    height: "40px",
                    children: /*#__PURE__*/ jsx(Icon, {
                        name: "search",
                        size: "24",
                        color: "text.light.tertirary"
                    })
                }),
                endAdornment: currentValue && /*#__PURE__*/ jsx(Box, {
                    px: "8",
                    position: "absolute",
                    right: 0,
                    children: /*#__PURE__*/ jsx(Button, {
                        size: "medium",
                        variant: "tertiaryLight",
                        onClick: ()=>{
                            onChange('');
                            setCurrentValue('');
                        },
                        testId: "cancel-button-test-id",
                        icon: /*#__PURE__*/ jsx(Icon, {
                            name: "dismiss_overlay",
                            size: "24"
                        })
                    })
                })
            },
            formHelperText: {
                classes: {
                    root: classes.helperText
                }
            }
        },
        size: "small",
        placeholder: placeholder || ''
    });
};
export { GlobalSearchInput };
